import React from 'react';
import { List, ListItem, ListItemText, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { formatLabel } from '../../../../Utils/Post/budget';

function Budget({ post, space }: any) {
  const intl = useIntl();

  if (!post.budget) {
    return null;
  }

  return (
    <List disablePadding>
      <ListItem disablePadding>
        <ListItemText
          primary={
            <FormattedMessage
              id="POSTS.BUDGET.BUDGET_VALUE"
              values={{
                budget: formatLabel(intl, post.budget, space.currency.key),
                b: (chunks: any) => (
                  <Typography component="b" sx={{ fontWeight: 'medium' }}>
                    {chunks}
                  </Typography>
                ),
              }}
            />
          }
        />
      </ListItem>
    </List>
  );
}

export default Budget;
